import axios from "axios"

const IP_URL = process.env.REACT_APP_IP_URL_MODULE
const PORT = process.env.REACT_APP_PORT_MODULE
const PROTOCOL = process.env.REACT_APP_PROTOCOL_MODULE

const headers = {
  'Content-Type': 'application/json'
}

export async function getRequestAPI(endpoint) {
  try {
    const response = await axios.get(`${PROTOCOL}://${IP_URL}:${PORT}/${endpoint}`)
    // console.log('response from get API function', response)
    if (response.status === 200) return response.data
  } catch (error) {
    //console.log(`error fetching data with endpoint: ${endpoint}`, error)
    return {
      mesagge: error.mesagge,
      status: 500,
      data: []
    }
  }
}

export async function putRequestAPI(endpoint, body) {
  try {
    const response = await axios.put(`${PROTOCOL}://${IP_URL}:${PORT}/${endpoint}`, body, {
     headers: headers
    })
    //console.log('response from put API function', response)
    if (response.status === 200) return response.data
  } catch (error) {
    //console.log(`error fetching data with endpoint: ${endpoint}`)
    return {
      mesagge: error.mesagge,
      status: 500,
      data: []
    }
  }
}

export async function postRequestAPI(endpoint, body) {
  try {
    const response = await axios.post(`${PROTOCOL}://${IP_URL}:${PORT}/${endpoint}`, body, {
     headers: headers
    })
    //console.log('response from put API function', response)
    if (response.status === 200) return response.data
  } catch (error) {
    //console.log(`error fetching data with endpoint: ${endpoint}`)
    return {
      mesagge: error.mesagge,
      status: 500,
      data: []
    }
  }
}